import { render, staticRenderFns } from "./navbar_button.vue?vue&type=template&id=37998444&"
import script from "./navbar_button.vue?vue&type=script&lang=js&"
export * from "./navbar_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports